import type { ListContextValue, ListItem } from "./list.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "ListContext",
  providerName: "ListProvider",
};

export const ListContext = createContext<ListContextValue | null>(null);

export const useListContext = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>() => {
  const contextValue = useContext(ListContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue as unknown as ListContextValue<DataItem, Metadata>;
};
